const MuiCard = {
  styleOverrides: {
    root: {
      boxShadow: '0px 4px 24px rgba(85, 100, 119, 0.08)'
    }
  }
};
export default MuiCard;